import {Component, OnInit} from '@angular/core';
import {SummaryModel} from '../../entity/summary.model';
import {WithSummaryModel} from '../../entity/dto/plain/withSummary.model';
import {ItemSummaryPlainEntityOrSummaryComponent} from '../../item/item-summary-plain-entity-or-summary/item-summary-plain-entity-or-summary.component';

@Component({
    template: `<p>This should never be visible</p>`
})
export abstract class SummaryPlainEntityOrSummaryComponent<
    Summary extends SummaryModel,
    Plain extends WithSummaryModel<Summary>>
    extends ItemSummaryPlainEntityOrSummaryComponent<Summary, Plain>
    implements OnInit {

}
